const template = {
  name: '',
  dateofbirth: '',
  studentID: '',
  degree: '',
  year: '',
  validFrom: '',
  validTo: '',
  photo: ''
}

const frankData = {
  name: 'F. D. Pierce',
  dateofbirth: '13-07-1998',
  studentID: '486230',
  degree: 'Economics and Business',
  degreeWithYear: 'Economics and Business 2023',
  year: '2023-2024',
  validFrom: '01-09-2023',
  validTo: '31-08-2024',
  photo: '/images/frankphoto.jpg'
}

const shaneData = {
  name: 'S. M. Dunne',
  dateofbirth: '26-11-1997',
  studentID: '486284',
  degree: 'Economics and Business',
  degreeWithYear: 'Economics and Business 2023',
  year: '2023-2024',
  validFrom: '01-09-2023',
  validTo: '31-08-2024',
  photo: '/images/shanephoto.jpg'
}

export { template, frankData, shaneData }
